<template>
  <section class="qrcode-reader-section">
    <qrcode-stream class="qrcode-reader-stream" :camera="camera" @decode="onDecode" @init="onInit"></qrcode-stream>
    <div class="qr-overlay-box">
      <label class="qr-overlay-label">{{ labelText }}</label>
      <div class="qr-inner-box"></div>
    </div>
    <div class="qr-scan-confirmation" v-show="showScanConfirmation">
      <i class="fas fa-check qr-checkmark"></i>
    </div>
  </section>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';

export default {
  name: 'QRCodeReader',
  components: {
    QrcodeStream,
  },
  props: {
    returnString: {
      type: Boolean,
      default: false,
    },
    labelText: {
      type: String,
      default: 'Posicione o QR Code para leitura',
    },
  },

  data() {
    return {
      camera: 'auto',
      result: null,
      showScanConfirmation: false,
    };
  },

  methods: {
    async onInit(promise) {
      try {
        const capabilities = await promise;
        // console.log('Successfully initilized! Ready for scanning now!', capabilities)
      } catch (e) {
        console.error(e);
      } finally {
        this.showScanConfirmation = this.camera === 'off';
      }
    },

    async onDecode(content) {
      this.result = content;

      let data;
      if (this.returnString) {
        // For cases where only the string is needed
        data = content;
      } else {
        // Default behavior for user identification
        data = {
          id: content,
          type: 'user_id',
        };
      }

      this.pause();
      await this.timeout(500);
      this.$emit('decode', data);
      this.unpause();
    },

    unpause() {
      this.camera = 'auto';
    },

    pause() {
      this.camera = 'off';
    },

    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    },
    switchCamera() {
      this.camera = this.camera === 'front' ? 'rear' : 'front';
    },
  },
};
</script>

<style lang="scss" scoped>
.qrcode-reader-section {
  position: fixed;
  width: 100vw;
  height: 100dvh;
  pointer-events: none;
  .qrcode-reader-stream {
    transform: scaleX(-1);
    @include media('<=tablet') {
      transform: scaleX(1);
    }
  }
  .qr-scan-confirmation {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);

    display: flex;
    align-items: center;
    justify-content: center;
  }
  .qr-checkmark {
    color: #00ff00;
    font-size: 100px;
    padding-bottom: 100px;
  }
  .qr-overlay-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    .qr-overlay-label {
      position: absolute;
      top: 120px;
      left: 0;
      right: 0;
      margin: auto;
      width: 100%;
      text-align: center;
      color: #fff;
      font-size: 20px;
      font-weight: bold;
      text-shadow: 0 0 10px #000;
    }

    .qr-inner-box {
      margin-top: 100px;
      width: 40vw;
      height: 40vw;
      border: 2px dashed #fff;
      background-color: transparent;
    }
  }
}
</style>
